export default {
  indigenousAndProtectedAreas: {
    title: "Indigenous & Protected Areas",
    titleTT: "All the report in the farm are checked if they are present inside any protected or indigenous area",
    subTitle: "All the farms in the report are checked if they are present inside any protected or indigenous areas in ",
    search: "Search",
    producer: "Producer",
    producerTT: "Select Name of Producer to filter",
    productionPlaceAndFarmId: "Production Place (Farm) & Farm ID",
    producerName: "Producer Name",
    addressOfProduction: "Address of Production",
    area: "Area (ha)",
    interceptsProtectedArea: "Intercepts Protected Area",
    interceptsIndigenousArea: "Intercepts Indigenous Area",
    riskMitigation: "Risk Mitigation",
    attachOneRiskMitigation: "Attach One Risk Mitigation Document for All Non-Compliant Farms",
    removeAllFlaggedFarms: "Remove All Flagged Farms",
    riskMitigationTitle: "Provide New Status",
    removeAllFlaggedFarmsTT: "This button will remove all farms whose status is 'Yes' in Intercept Protected Area and Intercept Indigenous Area Column",
    pleaseSelectManually:"Please select manually mitigated status.",
    attachFile: "Attach File",
    comments: "Comments",
    noInvasionOfProtectedAreas: "No invasion of protected areas",
    manuallyMitigated: "Manually mitigated",
  },
};